interface RecaptchaNoticeProps {
	className: string;
}

const legalLink = (href: string, label: string) => (
	<a href={href} target="_blank" rel="noopener noreferrer" className="underline">
		{label}
	</a>
);

export const RecaptchaNotice = ({ className }: RecaptchaNoticeProps) => {
	return (
		<span className={className}>
			{`This site is protected by reCAPTCHA and the Google `}
			{legalLink('https://policies.google.com/privacy', 'Privacy Policy')}
			{` and `}
			{legalLink('https://policies.google.com/terms', 'Terms of Service')}
			{` apply.`}
		</span>
	);
};
